import { render, staticRenderFns } from "./ModelingPatternDialog.vue?vue&type=template&id=fbe4615a&scoped=true&"
import script from "./ModelingPatternDialog.vue?vue&type=script&lang=js&"
export * from "./ModelingPatternDialog.vue?vue&type=script&lang=js&"
import style0 from "./ModelingPatternDialog.vue?vue&type=style&index=0&id=fbe4615a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe4615a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
